<template>
    <div class="infoengine">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-12">
                    <h2 class="filter-heading">Channel Type Factor</h2>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'tablet-table-xxs-min-width',
                'remove-sort-icon',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="data" :fields="fields">
                <template slot="worktypeimpact" slot-scope="data">
                    <div class="work-impact">
                        <span>{{ data.value }}</span>
                        <i class="icon-caret-right"></i>
                    </div>
                </template>
                <template slot="rating" slot-scope="data">
                    <base-status :status-type="data.value"></base-status>
                </template>
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('modify-channel-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <modify-channel-popup></modify-channel-popup>
        <base-records
            path="configurations/channel-types"
            :query="query"
            :reset="reset"
            :show-pagination="false"
        ></base-records>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import modifyChannelPopup from '@/components/popups/ModifyChannelPopup.vue'
export default {
    components: {
        modifyChannelPopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'code',
                    label: 'CHANNEL TYPE CODE',
                    sortable: false,
                },
                {
                    key: 'title',
                    label: 'CHANNEL TYPE TITLE',
                    sortable: false,
                },
                {
                    key: 'rating',
                    label: 'RATING',
                    class: 'text-center status-absolute-pos w-320px',
                    sortable: false,
                },
                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'single-list',
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 100,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'code',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
